// Custom ordered list component that supports listStyleType
// This allows us to preserve list numbering styles (a, b, c or i, ii, iii) from HTML

import type { TElement } from "@udecode/plate";
import type React from "react";

export interface CustomOrderedListProps {
  className?: string;
  children: React.ReactNode;
  element: TElement;
  attributes?: React.HTMLAttributes<HTMLOListElement>;
  [key: string]: any;
}

export const CustomOrderedList = ({ className, children, element, attributes, ...props }: CustomOrderedListProps) => {
  const listStyleType = (element as TElement & { listStyleType?: string }).listStyleType;

  // Apply listStyleType as inline style and data attribute
  // The data attribute allows CSS to target it if needed
  const style: React.CSSProperties = { ...attributes?.style };
  const dataAttributes: Record<string, string> = {};

  if (listStyleType) {
    style.listStyleType = listStyleType;
    dataAttributes["data-list-style-type"] = listStyleType;
  }

  return (
    <ol
      className={className}
      style={style}
      {...dataAttributes}
      {...attributes}
      {...props}
    >
      {children}
    </ol>
  );
};
